/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Unlock_ConfirmInputs */



/**
* | output |
* | --- |
* | "Yes, unlock it" |
*
* @param {Explorer_Info_Unlock_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_unlock_confirm = /** @type {((inputs?: Explorer_Info_Unlock_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Unlock_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Oui, deverrouiller")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja, entsperren Sie es.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sì, sbloccalo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Да, разблокируйте его.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sí, desbloquéalo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("是的，解锁它")
	if (locale === "ja") return /** @type {LocalizedString} */ ("はい、ロックを解除します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हां, इसे अनलॉक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sim, desbloqueie-o.")
	return /** @type {LocalizedString} */ ("Yes, unlock it")
});